import { useQuery } from '@tanstack/react-query';
import { fetchAttendance } from 'src/api/attendanceAPI';
import ApiError from 'src/api/errorHandling/ApiError';
import Attendance from 'src/models/Attendance';

export default function useAttendance(classId: number, studentUserId: number) {
  return useQuery<Attendance[], ApiError>({
    queryKey: ['attendance', classId, studentUserId],
    queryFn: () => fetchAttendance({ classId, studentUserId }),
  });
}
